import { hexagon } from '../config'
import { Description } from '../Description'

import {
  Roles,
  Wrapper,
  ImageWrapper,
  LeftHexagon,
  RightHexagon,
  Content,
  TeamImage,
  titleWrapperStyles,
  TeamHexagon,
} from './styles'
import { TeamMember } from './TeamMember'
import { TeamProps } from './types'

export function Team({ teamImage, teamMembers, title }: TeamProps) {
  return (
    <Wrapper>
      <Description title={title} wrapperAdditionalStyles={titleWrapperStyles} />
      <Content>
        <Roles>
          {teamMembers.map(teamMember => (
            <TeamMember key={teamMember.role} {...teamMember} />
          ))}
          <LeftHexagon />
          <RightHexagon />
          <TeamHexagon {...hexagon} />
        </Roles>
        <ImageWrapper>
          <TeamImage {...teamImage} fill />
        </ImageWrapper>
      </Content>
    </Wrapper>
  )
}
